const trimTrailingSlash = (value) => String(value || "").trim().replace(/\/+$/, "")

const normalizeApiBaseUrl = (value) => {
  const trimmed = trimTrailingSlash(value)
  if (!trimmed) return ""

  try {
    const url = new URL(trimmed.includes("://") ? trimmed : `http://${trimmed}`)
    return trimTrailingSlash(url.toString())
  } catch (error) {
    return trimmed
  }
}

const resolveApiBaseUrl = () => {
  const configuredBaseUrl =
    process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || process.env.APP_API_URL || ""

  if (configuredBaseUrl) {
    return normalizeApiBaseUrl(configuredBaseUrl)
  }

  if (typeof window !== "undefined" && window.location) {
    return trimTrailingSlash(window.location.origin)
  }

  return ""
}

const toHost = (value) => {
  const trimmed = trimTrailingSlash(value)
  if (!trimmed) return ""

  try {
    return new URL(trimmed.includes("://") ? trimmed : `http://${trimmed}`).host
  } catch (error) {
    return trimmed.replace(/^(https?|wss?):\/\//, "").split("/")[0]
  }
}

export const API_BASE_URL = resolveApiBaseUrl()
export const IS_LOCAL_API = /(^|\/\/)(localhost|127\.0\.0\.1)(:|\/|$)/.test(API_BASE_URL)
export const WS_HOST = toHost(process.env.REACT_APP_WS_HOST) || toHost(API_BASE_URL)

export const getWebSocketUrl = (token) => {
  const explicitUrl = trimTrailingSlash(process.env.REACT_APP_WS_URL)
  const query = token ? `?token=${encodeURIComponent(token)}` : ""

  if (explicitUrl) {
    return `${explicitUrl}${explicitUrl.endsWith("/ws") ? "" : "/ws"}${query}`
  }

  const host = WS_HOST || (typeof window !== "undefined" ? window.location.host : "")
  const useSecureProtocol =
    API_BASE_URL.startsWith("https://") || (typeof window !== "undefined" && window.location.protocol === "https:")
  const protocol = useSecureProtocol ? "wss" : "ws"

  return `${protocol}://${host}/ws${query}`
}
